import dynamic from 'next/dynamic'
import { dollarSymbolFormatter } from 'src/utils/string'
import { formatCurrency2String } from 'src/utils/number/currency'
import { ENTITY, BTCtoSAT } from 'src/consts'
import { Icon } from 'src/components/Icon'
import useWidth from 'src/hooks/useWidth'
import Colors from 'src/components/TreeMap/components/Colors'
import styles from './styles.module.scss'
import { AddToWatchlist } from '../AddToWatchlist'
import { intl } from 'src/i18n'

const CoinButtonBanner = dynamic(
  () => import('src/components/Banners/CoinButtonBanner'),
  { ssr: false }
)

const colors = new Colors().createScale()

export const TopInfoBlock = ({ data }) => {
  const {
    slug,
    name,
    code,
    price,
    change,
    priceBtc,
    marketCapRank,
    marketCap,
    volume,
    volumeBtc,
    emission,
    totalSupply,
    marketCapBtc,
  } = data
  const { isMobile } = useWidth()
  const renderSymbolPriceChange = () => {
    return (
      <div
        className={styles.priceChange}
        style={{
          color: colors(Math.round(change * 100) / 100),
        }}
      >
        {price === 0 ? '' : `(${change}%)`}
      </div>
    )
  }

  const safePriceBTC =
    priceBtc < 1e-8
      ? `${(priceBtc * BTCtoSAT).toFixed(4)} SAT`
      : `${priceBtc.toFixed(8)} BTC`

  const renderIntegrationButton = () => (
    <>
      <CoinButtonBanner place={'503528'} key='first' width={116} />
      <CoinButtonBanner place={'503536'} key='second' width={121} />
      <CoinButtonBanner place={'503539'} key='third' width={121} />
      <CoinButtonBanner place={'503546'} key='fourth' width={121} />
      <CoinButtonBanner place={'503538'} key='fifth' width={132} />
    </>
  )

  return (
    <div className={styles.wrapper}>
      <div className={styles.symbolContainer}>
        {isMobile && <AddToWatchlist code={slug} isMobile={isMobile} />}
        <Icon data={{ slug, name }} size='48x48' entity={ENTITY.COIN} />
        <h1 className={styles.symbol}>
          {name}
          {code && <span>({code})</span>}
        </h1>
        {!isMobile && <AddToWatchlist code={slug} />}
      </div>
      <div className={styles.marketContainer}>
        <div className={styles.usdContainer}>
          <div className={styles.usdPrice}>
            {dollarSymbolFormatter(formatCurrency2String(price))}
          </div>
          {renderSymbolPriceChange(change, price)}
        </div>
        <div className={styles.btcPrice}>
          {safePriceBTC === '0.0000 SAT' ? '? SAT' : safePriceBTC}
        </div>
        {/* <div className={styles.integrationButtonContainer}>
          {renderIntegrationButton()}
        </div> */}
        <div className={styles.marketData}>
          <div className={styles.marketDataItem}>
            <div className={styles.label}>{`${intl.t(
              'coinDetails.topInfoBlock.label1'
            )}${isMobile ? '' : ` (Rank#${marketCapRank})`}`}</div>
            <div className={styles.value}>
              {dollarSymbolFormatter(
                formatCurrency2String(marketCap, false, '0,0')
              )}
            </div>
            <div className={styles.btcValue}>
              {formatCurrency2String(marketCapBtc, false, '0,0')} BTC
            </div>
          </div>
          <div className={styles.marketDataItem}>
            <div className={styles.label}>
              {' '}
              {intl.t('coinDetails.topInfoBlock.label2')}
            </div>
            <div className={styles.value}>
              {dollarSymbolFormatter(
                formatCurrency2String(volume, false, '0,0')
              )}
            </div>
            <div className={styles.btcValue}>
              {formatCurrency2String(volumeBtc, false, '0,0')} BTC
            </div>
          </div>
          <div className={styles.marketDataItem}>
            <div className={styles.label}>
              {intl.t('coinDetails.topInfoBlock.label3')}
            </div>
            <div className={styles.value}>
              {formatCurrency2String(emission)}
            </div>
          </div>
          {totalSupply >= 0 && (
            <div className={styles.marketDataItem}>
              <div className={styles.label}>
                {intl.t('coinDetails.topInfoBlock.label4')}
              </div>
              <div className={styles.value}>
                {formatCurrency2String(totalSupply)}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default TopInfoBlock
